import { useTranslations } from '@chilipiper/locale'

export const useLabelTranslation = () => {
  const [
    myPhone,
    hostsPhone,
    myLocation,
    hostsLocation,
    useHostsSettings,
    useHostsConferenceDetails,
    provideMyOwn,
    provideYourOwnMeetingLink,
    enter,
    meetingLocation,
    phone,
    callTheHost,
    callTheGuest,
  ] = useTranslations([
    'myPhone',
    'hostsPhone',
    'myLocation',
    'hostsLocation',
    'useHostsSettings',
    'useHostsConferenceDetails',
    'provideMyOwn',
    'provideYourOwnMeetingLink',
    'enter',
    'meetingLocation',
    'phone',
    'callTheHost',
    'callTheGuest',
  ])

  const map: Record<string, string> = {
    myPhone,
    hostsPhone,
    myLocation,
    hostsLocation,
    useHostsSettings,
    useHostsConferenceDetails,
    provideMyOwn,
    provideYourOwnMeetingLink,
    enter,
    meetingLocation,
    phone,
    callTheHost,
    callTheGuest,
  }

  return map
}
